import Tabs from "../../../common/Tabs";
import Tab from "../../../common/Tab";
import DynamicContent from "../../../nav/DynamicContent";
import {Assessment, Assignment, Edit, List} from "@mui/icons-material";
import TestGroups from "./TestGroups/TestGroups";
import React, {useEffect, useState, useContext} from "react";
import DiagnosticWizard from "./TestGroups/Wizard/PreTest";
import AssignedTestsTab from "./AssignFollowUpWork/AssignedTestsTab.js"
import TestGroupReports from "./Reports/TestGroupReports";
import {BrandContext} from "../../../common/BrandContext";

const TestGroupTabs = (props) => {
    const TABS = {
            TESTS: {val: 0, hash: 'families'},
            ASSIGNED: {val: 1, hash: 'assigned'},
            REPORTS: {val: 2, hash: 'reports'},
            EDIT: {val: 3, hash: 'edit'}
        },
        EditAssignObject = {
            formatType: {ASSESSMENT: {name: 'One sitting', val: "ASSESSMENT"}, REVISION: {name: 'Multiple sittings', val: "REVISION"}},
            FORMAT_TOOLTIP: <div><p>Assessment format: To be completed in one sitting, with answers provided on assessment expiry.</p>
                <p>Revision format: Can be completed over a number of sittings, with answers provided immediately on submission.</p></div>,
            START_END_DATE_TOOLTIP_ASSESSMENT: <div>
                <p>Students can begin the test after the start time.</p>
                <p>Students need to complete and submit the test by the expiry time.</p>
            </div>,
            START_END_DATE_TOOLTIP_REVISION: <div>
                <p>Students can begin revision after the start time.</p>
                <p>Students need to complete and submit the revision by the expiry time.</p>
            </div>,
            START_END_DATE_TOOLTIP: <div className={'tooltip-wrapper'}>
                <p>Students can begin the test after the start time.</p>
                <p>Students need to complete and submit the test by the expiry time.</p>
            </div>,
            SHOW_RESULTS_ON_EXPIRY_TOOLTIP: <div className={'tooltip-wrapper'}>
                <p>One sitting assignments: Results can be viewed upon test expiry.</p>
                <p>Multiple sitting assignments: Results can be viewed immediately on submission</p>
            </div>
        }

    const [tabVal, setTabVal] = useState(),
        [editTest, setEditTest] = useState(null),
        [showEditWizard, setShowEditWizard] = useState(false),
        [refreshTestGroupId, setRefreshTestGroupId] = useState(null),
        brandConfig = useContext(BrandContext),
        [refreshTestAssignmentSearch, setRefreshTestAssignmentSearch] = useState(null);

    const handleTabChange = val => {

        if (editTest !== null && val !== TABS.EDIT.val) {
            setRefreshTestGroupId(editTest.testGroupId);
            setEditTest(null);
        }
    }

    useEffect(()=>{
        if(editTest != null){
            setTabVal(TABS.EDIT.val);
        }else{
            setTabVal(undefined);
        }
    },[editTest]);

    const handleRefreshTestAssignmentSearch = ()=>{
        setRefreshTestAssignmentSearch(new Date().getTime());
    }

    return (<Tabs onChange={handleTabChange} id={'teacherTestGroupTabs'} activeKey={tabVal} variant="standard">
            <Tab id={'diagnosticTests'}
                 hash={TABS.TESTS.hash}
                children={<TestGroups setUseEditWizard={setShowEditWizard} showEditWizard={showEditWizard} setEditTest={setEditTest} editTest={editTest} editAssignObj={EditAssignObject} refreshTestGroupId={refreshTestGroupId} setRefreshTestGroupId={setRefreshTestGroupId} triggerTestAssignmentSearch={handleRefreshTestAssignmentSearch} />}
                tab={
                    <>
                        <List className={'margin-r--m'}/>
                        <span className={'margin-r--m tabText'}>Test families</span>
                    </>
                }
                key={TABS.TESTS.val} value={TABS.TESTS.val}/>
            <Tab id={'diagnosticTestAssignments'}
                 hash={TABS.ASSIGNED.hash}
                children={<AssignedTestsTab editAssignObj={EditAssignObject} refreshTestAssignmentSearch={refreshTestAssignmentSearch} />}
                tab={
                    <>
                        <Assignment className={'margin-r--m'}/>
                        <span className={'margin-r--m tabText'}>Manage assigned tests / Assign {brandConfig.diagnosticFeedbackName.toLowerCase()}</span>
                    </>
                }
                key={TABS.ASSIGNED.val} value={TABS.ASSIGNED.val}/>
            <Tab id={'diagnosticReportsTab'}
                 hash={TABS.REPORTS.hash}
                children={<TestGroupReports style={{overflowX: 'none'}}/>}
                tab={
                    <>
                        <Assessment className={'margin-r--m'}/>
                        <span className={'margin-r--m tabText'}>Reports</span>
                    </>
                }
                key={TABS.REPORTS.val} value={TABS.REPORTS.val}/>
            <Tab id={'testEdit'} disabled={editTest == null}
                 hash={TABS.EDIT.hash}
                 children={
                    <>
                        {editTest && showEditWizard && (
                            <DiagnosticWizard editTest={editTest} setShowEditWizard={setShowEditWizard} />
                        )}
                        {editTest && showEditWizard == false && (
                            <DynamicContent url={'/controlCentre/editTest.action'} params={{testId:editTest.testId, showBackButton:false}}/>
                        )}
                    </>
                }
                 tab={
                     <>
                         <Edit className={'margin-r--m'}/>
                         <span className={'margin-r--m tabText'}>Test edit</span>
                     </>
            } key={TABS.EDIT.val} value={TABS.EDIT.val}/>
        </Tabs>
    )
}
export default TestGroupTabs;
